/**
 * Servicio para permite enviar las peticiones realizadas con eventos de JQuery.
 * JMM-2019-02-11
 */
import { Injectable } from '@angular/core';
import { ConfigService } from '../../servicios/config/config.service';
import { Http, Response } from '@angular/http';
import { KeyService } from '../../servicios/key.service'; 
import { Router, ActivatedRoute } from '@angular/router';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Injectable()
export class EventosJqueryService {

  nitEmpresa  : any = localStorage.getItem('nitEmpresa');
  usuarioid   : any = localStorage.getItem('usuarioid');

  PATH        = new ConfigService().obtenerPath();
  
  constructor(
    private http    : Http,
    private router  : Router,
    private _key    : KeyService
  ) {}

  /**
   * Permite escuchar el evento de la tecla Enter en los forumarios.
   * Esto es, que al presionar la tecla Enter se puede saltar entre campos de los formularios.
   * JMM-2019-02-11
   */
  eventoTeclaEnter()
  {
    $(document).on('keydown', "input:not(button, #password, [type=search]), select, span[contenteditable]", function(evt)
    {
      if (evt.keyCode == 13) 
      {
        let iname = $(this).val();
        if (iname !== 'Submit') 
        {
          var fields = $(this).parents('form:eq(0),body').find('button:visible, input:visible, textarea:visible, select:visible, span[contenteditable]:visible');
          var index = fields.index(this);
          if (index > -1 && (index + 1) < fields.length) 
          {
            if( ( ! fields.eq(index + 1).attr('disabled')) && ( ! fields.eq(index + 1).attr('readonly')) )
            {
              if (fields.eq(index + 1).is('button')) {
                fields.eq(index + 1).click();
              } else {
                fields.eq(index + 1).focus();
              }
            } else {
              $(this).change().focusout();
            }
          } else {
            //alert("error");
          }
          return false;
        }
      }
    });
  }// .eventoTeclaEnter()
  
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/eventos-jquery/eventos-jquery.service.ts